<template>
  <el-form
      ref="form"
      :model="form"
      label-width="120px"
      class="transport-from gj-table-parent_flex"
      :class="{'info-form': viewOpType}"
      :label-suffix="viewOpType ? '' : ''">
    <div class="product-items">
      <el-form-item
          label="关税申报单价"
          label-width="90px"
          prop="tax.price"
          :class="{'row-height': viewOpType}"
          :rules="[ $gjReRule(RE.num(2), '请输入最多2位小数的正数') ]">
        <template v-if="viewOpType">
          <template v-if="isMeaningful(form.tax.price)">
            {{  form.tax.currency | optionText(currencyOption, 'id', 'currencySymbol') }}{{form.tax.price}}
          </template>
          <template v-else>-</template>
        </template>
        <gj-select-input
            v-else
            v-model="form.tax"
            :prop="{key: 'currency', value: 'price'}"
            :options="currencyOption"
            :search="false"
            :width="['100px', '100px']"
            :placeholder="['', '单价']"
        ></gj-select-input>
      </el-form-item>
      <el-form-item
          label="中文报关名"
          label-width="90px"
          :class="{'row-height': viewOpType}"
          prop="chineseCustomsName">
        <template v-if="viewOpType">{{form.chineseCustomsName | defaultShow}}</template>
        <gj-input
            v-else
            v-model="form.chineseCustomsName"
            width="200px"
            placeholder="中文报关名"
        ></gj-input>
      </el-form-item>
      <el-form-item
          label="英文报关名"
          label-width="90px"
          :class="{'row-height': viewOpType}"
          prop="englishCustomsName">
        <template v-if="viewOpType">{{form.englishCustomsName | defaultShow}}</template>
        <gj-input
            v-else
            v-model="form.englishCustomsName"
            width="200px"
            placeholder="英文报关名"
        ></gj-input>
      </el-form-item>
    </div>
    <div style="flex: 1; overflow: auto">
      <gj-table
            :data="form.customsCode"
            adaptParent
            :columns="columns"
            class="gj-table"
            >
          <template v-slot:code="{ index, row }">
            <template v-if="viewOpType">{{row.code | defaultShow}}</template>
            <el-form-item
                v-else
                :prop="`customsCode.${index}.code`"
                class="gj-table-item">
              <gj-input
                  v-model="form.customsCode[index].code"
                  width="150px">
              </gj-input>
            </el-form-item>
          </template>
        </gj-table>
    </div>
  </el-form>
</template>

<script>
  import {formRuleMixin, formValidatorMixin, isMeaningfulMixin, opTypeMixin} from "../../../../../../minxins";
  import {countryOption} from "../../../../../../utils/options";

  export default {
    name: "app-product-transport-form",
    mixins: [formValidatorMixin, formRuleMixin, opTypeMixin, isMeaningfulMixin],
    props: {
      form: {
        required: true
      }
    },
    data() {
      return {
        columns: [
          {id: 'countryCode', header: '国家', field: 'option:countryCode', minWidth: '50px', options: countryOption},
          {id: 'code', header: '海关编码', field: 'slot:code', minWidth: '50px'},
        ],
        currencyOption: [
          {id: 'CNY', text: 'CNY', currencySymbol: '￥'},
          {id: 'USD', text: 'USD', currencySymbol: '$'}
        ]
      }
    }
  }
</script>

<style lang="scss" scoped>
  .gj-table /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }
  .transport-from {
    margin-right: 0;
  }
  .product-items{
    display: flex;
    .el-form-item{
      margin-right: 30px;
    }
  }
  /deep/ .el-form-item__content{
    color: #333;
  }
  // /deep/ .el-form-item{
  //   margin-bottom: 12px;
  // }
  .row-height{
    /deep/ .el-form-item__label, /deep/.el-form-item__content{
      line-height: 17px;
    }
  }
  .info-form {
    /deep/ .el-form-item__label, /deep/.el-form-item__content{
      line-height: 20px;
    }
    /deep/ .el-form-item{
      margin-bottom: 12px;
    }
    /deep/ .gj-area-title{
      // margin-bottom: 24px;
    }
  }
</style>
